import React, { useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = useCallback((sectionId) => {
    if (location.pathname === "/") {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: sectionId } });
    }
  }, [location.pathname, navigate]);

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="nav-logo" aria-label="Hayden Bulk Tech Labs home">
              <img
                src="/hayden-bulk.png"
                alt="Hayden Bulk Tech Labs logo"
                width="46"
                height="44"
              />
              <span>Hayden Bulk Tech Labs</span>
            </Link>
            <p>Digital Products &bull; AI &bull; SaaS &bull; Blockchain</p>
          </div>

          <div className="footer-col">
            <h4>Products</h4>
            <ul>
              <li>
                <a href="https://privateer.pro" target="_blank" rel="noopener noreferrer">
                  Privateer
                </a>
              </li>
              <li>
                <a href="https://www.chattybooks.com" target="_blank" rel="noopener noreferrer">
                  ChattyBooks
                </a>
              </li>
              <li>
                <a href="https://www.fullgrooveradio.com" target="_blank" rel="noopener noreferrer">
                  Full Groove Radio
                </a>
              </li>
              <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => scrollToSection("products")}
                >
                  Farty Unicorn
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => scrollToSection("about")}
                >
                  About
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => scrollToSection("services")}
                >
                  Services
                </button>
              </li>
              <li>
                <Link to="/partners">Partners</Link>
              </li>
              <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => scrollToSection("contact")}
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Resources</h4>
            <ul>
              <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => scrollToSection("engagement")}
                >
                  How We Work
                </button>
              </li>
            </ul>
          </div>
        </div>

        <p className="footer-wordmark" aria-hidden="true">
          Hayden Bulk<span>.</span>
        </p>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Hayden Bulk Tech Labs. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
